import moment from "moment";

export default {
  install(app) {
    app.config.globalProperties.$formatDate = function (date) {
      return moment(date).format("DD.MM.YYYY");
    };
  },
};
